gsap.registerPlugin(ScrollTrigger);
//gsap.registerPlugin(toggleClass)
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

const homeAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      
      let sectionCreation = document.querySelector(".section-creation");
      let creationText = document.querySelector(".section-creation .text-side");
      let creationImg = document.querySelector(".section-creation .image-side");

      let dispoText = document.querySelector(".section-dispositif .text-side");
      let dispoImg = document.querySelector(".section-dispositif .image-side");

      let atelierText = document.querySelector(".section-atelier .text-side");
      let atelierImg = document.querySelector(".section-atelier .image-side");
      
      /* SECTION CREATIONS */
      gsap.from(creationText, {
        scrollTrigger: {
          
          trigger:'.section-creation',
          markers: false,
          start: 'top 75%',
          //scrub: true,
          toggleActions: "play none none reverse",
        },
        opacity: 0,
        x:100,
      },)
      ;

      /* gsap.from(creationImg, {
        scrollTrigger: {
          
          trigger:'.section-creation',
          markers: true,
          start: 'top 75%',
          //scrub: true,
          //toggleActions: "play none none reverse",
        },
        opacity: 0,
        y:100,
        
      }) */


      /* SECTION DISPOSITIFS */
      gsap.from(dispoText, {
        scrollTrigger: {
          
          trigger:'.section-dispositif',
          markers: false,
          start: 'top 75%',
          //scrub: true,
          toggleActions: "play none none reverse",
        },
        opacity: 0,
        x:-100,
      },)
      ;

      /* gsap.from(dispoImg, {
        scrollTrigger: {
          
          trigger:'.section-dispositif',
          markers: true,
          start: 'top 75%',
          //scrub: true,
          //toggleActions: "play none none reverse",
        },
        opacity: 0,
        y:100,
      }) */

        /* SECTION ATELIERS */
      gsap.from(atelierText, {
        scrollTrigger: {
          
          trigger:'.section-atelier',
          markers: false,
          start: 'top 75%',
          //scrub: true,
          toggleActions: "play none none reverse",
        },
        opacity: 0,
        x:100,
      },)
      ;

      /* gsap.from(dispoImg, {
        scrollTrigger: {
          
          trigger:'.section-dispositif',
          markers: true,
          start: 'top 75%',
          //scrub: true,
          //toggleActions: "play none none reverse",
        },
        opacity: 0,
        y:100,
      }) */
  

    });
  },
};

export default homeAnim;
